module.exports = __webpack_public_path__ + "assets/img/tab3_06.60f603aa.jpg";